// @flow
import React, { Component } from 'react'
import { translations, translateFunc } from '../../shared/localize'
import type { AutomatedRulesLog } from '../types'

import { BodyRow, Cell } from '../../components/MainTable'
import styled from 'styled-components'

const MenuLink = styled.a`
  text-decoration: none;
`

type Props = {
  log: AutomatedRulesLog
}

const t = translateFunc(translations.automated_rules_logs_table)

export default class Row extends Component<Props> {
  render() {
    const { log } = this.props
    return (
      <BodyRow>
        <Cell alignLeft>{log.logged_at}</Cell>
        <Cell alignLeft>
          <MenuLink href={log.editRulePath}>{log.rule_name}</MenuLink>
        </Cell>
        <Cell alignLeft>
          {log.owner_id && (
            <MenuLink href={log.editOwnerPath}>
              {t('owner', { id: log.owner_id, type: t(log.owner_type) })}
            </MenuLink>
          )}
        </Cell>
        <Cell>{log.message}</Cell>
      </BodyRow>
    )
  }
}
